import React, { Suspense } from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { EduProvider } from './context/EduContext';
import { Layout } from './components/Layout';
import { ErrorBoundary } from './components/ErrorBoundary';

// Lazy Load Pages
const Home = React.lazy(() => import('./pages/Home'));
const Programs = React.lazy(() => import('./pages/Programs'));
const Admissions = React.lazy(() => import('./pages/Admissions'));
const About = React.lazy(() => import('./pages/About'));
const Contact = React.lazy(() => import('./pages/Contact'));
const Reviews = React.lazy(() => import('./pages/Reviews'));
const CourseDetail = React.lazy(() => import('./pages/CourseDetail'));
const NotFound = React.lazy(() => import('./pages/NotFound'));

const PageLoader = () => (
  <div className="min-h-screen flex flex-col items-center justify-center bg-indigo-50">
    <Loader2 className="animate-spin text-indigo-600 w-10 h-10 mb-4" />
    <p className="font-serif text-gray-500 animate-pulse">Loading Aziz Edu - Computer Science University...</p>
  </div>
);

function App() {
  return (
    <ErrorBoundary>
      <EduProvider>
          <Router>
            <Suspense fallback={<PageLoader />}>
              <Routes>
                {/* Student Routes */}
                <Route path="/*" element={
                   <Layout>
                      <Routes>
                        <Route index element={<Home />} />
                        <Route path="programs" element={<Programs />} />
                        <Route path="programs/:courseId" element={<CourseDetail />} />
                        <Route path="admissions" element={<Admissions />} />
                        <Route path="about" element={<About />} />
                        <Route path="contact" element={<Contact />} />
                        <Route path="reviews" element={<Reviews />} />
                        <Route path="*" element={<NotFound />} />
                      </Routes>
                   </Layout>
                } />
              </Routes>
            </Suspense>
          </Router>
      </EduProvider>
    </ErrorBoundary>
  );
}

export default App;
